import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

export const assetRoutes: Route = {
    path: 'asset',
    data: { title: 'asset' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'land' },
        {
            path: 'asset-ownership',
            loadComponent: () =>
                import('./asset-ownership/asset-ownership.component').then((m) => m.AssetOwnershipComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'asset-ownership' },
        },
        {
            path: 'asset-certification-type',
            loadComponent: () =>
                import('./asset-certification-type/asset-certification-type.component').then(
                    (m) => m.AssetCertificationTypeComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'asset-certification-type' },
        },
        {
            path: 'land',
            loadComponent: () => import('./land/land.component').then((m) => m.LandComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Land' },
        },
        {
            path: 'note',
            loadComponent: () => import('./note/note.component').then((m) => m.NoteComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Note' },
        },
        {
            path: 'plantation',
            loadComponent: () => import('./plantation/plantation.component').then((m) => m.PlantationComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Plantation' },
        }, 
        {
            path: 'plantation-user',
            loadComponent: () =>
                import('./plantation-user/plantation-user.component').then((m) => m.PlantationUserComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'plantation-user' },
        },
        {
            path: 'land-regenerative-practice',
            loadComponent: () =>
                import('./land-regenerative-practice/land-regenerative-practice.component').then(
                    (m) => m.LandRegenerativePracticeComponent,
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'land-regenerative-practice' },
        },
        {
            path: 'rotation',
            loadComponent: () => import('./rotation/rotation.component').then((m) => m.RotationComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Rotation' },
        },
    ],
};
